var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floatLayer"},[_c('div',{staticClass:"close-btn",on:{"click":function($event){$event.stopPropagation();return _vm.closeView.apply(null, arguments)}}},[_vm._v("×")]),_c('img',{staticStyle:{"width":"300px","height":"450px","z-index":"999999"},attrs:{"src":_vm.json.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }